let baseUrl = 'https://erp.glasstechnika.pl/';
// let baseUrl = 'https://erp.glasstechnika.pl/';

export default {
	apiUrl: baseUrl+'api/web/v1/',
	//apiUrl: 'http://glasstechnika.pawel.labs.webdev.pl/',
	sampleHardeningImgaesUrl: 'https://erp.glasstechnika.pl/uploads/dedicated/sample_hardening/',
	baseUrl: '/'
}



/** WEBPACK FOOTER **
 ** ./js/config.js
 **/